<template>
  <v-dialog v-model="visible" persistent max-width="380px">
    <v-card>
      <v-card-title class="pl-4">
        <h2>登录{{appName}}</h2>
        <v-spacer></v-spacer>
        <v-btn icon @click="visible = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-4">
        <v-form ref="form" lazy-validation>
          <div>
            <v-text-field v-model="form.loginName" :rules="rules.loginName" label="手机号" solo></v-text-field>
          </div>
          <div>
            <v-text-field
              v-model="form.password"
              :rules="rules.password"
              label="密码"
              type="password"
              solo
            ></v-text-field>
          </div>
          <div
            :class="{hidden:error.length === 0}"
            class="error--text"
          >{{ error.length > 0? error:"错误信息" }}</div>
          <div>
            <v-btn :loading="loading" color="primary" large block @click="login">登 录</v-btn>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <div class="primary-text privacy-text" >
          <router-link to="/information?tab=3" target="_blank">《隐私政策》</router-link>
        </div>
        <router-link to="" class="introduce-text">忘记密码</router-link>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/assets/js/validate";
export default {
  name: "CLogin",
  data() {
    return {
      appName: process.env.VUE_APP_Name,
      form: {
        loginName: "",
        password: ""
      },
      rules: {
        loginName: [
          v => {
            if (!v) {
              return "请输入手机号";
            }
            // if (!validate.isMobilePhone(v)) {
            //   return "请输入正确的手机号";
            // }
            return true;
          }
        ],
        password: [
          v => {
            if (!v) {
              return "请输入密码";
            }
            if (!validate.isPassword(v)) {
              return "密码格式错误，只能包含6-20位数字、字母、下划线";
            }
            return true;
          }
        ]
      },
      error: "",
      loading: false
    };
  },
  computed: {
    visible: {
      get() {
        return this.$store.state.loginVisible;
      },
      set(v) {
        this.$store.commit("setLoginVisible", v);
      }
    }
  },
  created() {
    if (process.env.NODE_ENV === "development") {
      this.form = {
        loginName: "17600575463",
        password: "123456"
      };
    }
  },
  methods: {
    login() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.loading = true;
      this.$store
        .dispatch("login", this.form)
        .then(() => {
          this.visible = false;
          this.loading = false;
        })
        .catch(err => {
          this.error = err;
          this.loading = false;
        });
    },
    callPrivacy(){

    }
  }
};
</script>
<style lang="scss" scoped>
  .privacy-text{
    margin-right: 5px;
    font-size: 14px;
    cursor: pointer;
  }
</style>
